export default function ClassLogo({ size = "md" }) {
  const sizes = {
    sm: {
      wrap: "w-8 h-8 rounded-[10px]",
      inner: "inset-[3px] rounded-[7px]",
      text: "text-[1.05rem]",
      left: "left-[7px]",
      right: "right-[7px]",
      topDot: "top-[7px]",
      bottomDot: "bottom-[7px]",
    },
    md: {
      wrap: "w-11 h-11 rounded-[13px]",
      inner: "inset-[4px] rounded-[9px]",
      text: "text-[1.45rem]",
      left: "left-[9px]",
      right: "right-[9px]",
      topDot: "top-[9px]",
      bottomDot: "bottom-[9px]",
    },
  };

  const s = sizes[size] ?? sizes.md;

  return (
    <div
      className={`relative ${s.wrap} shrink-0 overflow-hidden border border-white/80 bg-gradient-to-br from-[#ecfaf5] via-[#e2f7f1] to-[#f8efe3] shadow-[0_8px_22px_rgba(15,23,42,0.06)]`}
    >
      <div className={`absolute ${s.inner} border border-white/70`} />

      <div
        className={`absolute top-1 ${s.left} w-3 h-3 border-t-2 border-l-2 border-[#7dc8c0] rounded-tl-[6px] opacity-90`}
      />
      <div
        className={`absolute bottom-1 ${s.right} w-3 h-3 border-b-2 border-r-2 border-[#e7c86d] rounded-br-[6px] opacity-90`}
      />

      <div
        className={`absolute ${s.left} ${s.topDot} w-1 h-1 rounded-full bg-[#7dc8c0] shadow-[0_0_8px_rgba(125,200,192,0.45)]`}
      />
      <div
        className={`absolute ${s.right} ${s.bottomDot} w-1 h-1 rounded-full bg-[#e7c86d] shadow-[0_0_8px_rgba(231,200,109,0.45)]`}
      />

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="flex items-end leading-none select-none">
          <span
            className={`font-display font-semibold ${s.text} tracking-[-0.08em]`}
            style={{
              background:
                "linear-gradient(180deg, #5C7CA3 0%, #83AEC9 55%, #B9D8E9 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            R
          </span>
          <span
            className={`font-display font-semibold ${s.text} tracking-[-0.10em] ml-[-1px]`}
            style={{
              background:
                "linear-gradient(180deg, #F3DA8B 0%, #E7C86D 48%, #C9A44C 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            B
          </span>
        </div>
      </div>

      <div className="absolute inset-x-2 bottom-0 h-3 bg-gradient-to-t from-white/20 to-transparent" />
    </div>
  );
}